import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {
  NbButtonModule,
  NbCalendarRange,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbPopoverDirective,
  NbPopoverModule
} from '@nebular/theme';
import {TuiDayRange} from '@taiga-ui/cdk';
import {TuiCalendarRange} from "@taiga-ui/kit";

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker-component.html',
  imports: [
    NbFormFieldModule,
    TuiCalendarRange,
    NbIconModule,
    NbInputModule,
    NbPopoverModule,
    NbButtonModule,
    ReactiveFormsModule
  ],
  standalone: true
})
export class DatepickerComponent implements OnInit {
  control = new UntypedFormControl();

  @Input() value: TuiDayRange;
  @Output() rangeSelect: EventEmitter<NbCalendarRange<Date>> = new EventEmitter<NbCalendarRange<Date>>();
  @Output() rangeSelectTui: EventEmitter<TuiDayRange> = new EventEmitter<TuiDayRange>();

  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;

  ngOnInit() {
    if (this.value) {
      this.control.patchValue(this.value);
    }
  }

  dateFilter(dayRange: TuiDayRange) {
    this.control.patchValue(
      dayRange.from.getFormattedDay('YMD', '-') + ' ' + dayRange.to.getFormattedDay('YMD', '-')
    );
    this.popover.hide();

    const range: NbCalendarRange<Date> = {
      start: dayRange.from.toLocalNativeDate(),
      end: dayRange.to.toLocalNativeDate(),
    };

    this.rangeSelect.emit(range);
    this.rangeSelectTui.emit(dayRange);
  }

  clear(): void {
    this.control.patchValue(null);
  }
}
